const cleanPageUrl = window.location.origin + window.location.pathname;

let pendingQueueitToken = (() => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("queueittoken") ?? "";
  if (token) {
    url.searchParams.delete("queueittoken");
    window.history.replaceState({}, "", url.toString());
  }
  return token;
})();

let redirectInFlight = false;

export const getCleanPageUrl = () => cleanPageUrl;

export const getQueueitToken = (): string => pendingQueueitToken;

export const clearQueueitToken = () => {
  pendingQueueitToken = "";
};

export const handleQueueitRedirectHeader = (headers: Record<string, any>): boolean => {
  if (redirectInFlight) return true;

  const redirect =
    headers?.["x-queueit-redirect"] ??
    headers?.["X-Queueit-Redirect"] ??
    headers?.["x-queueit-ajaxpageurl"] ??
    headers?.["X-Queueit-Ajaxpageurl"];

  if (!redirect) return false;

  redirectInFlight = true;
  const url = typeof redirect === "string" ? decodeURIComponent(redirect) : "";
  if (url) {
    window.location.replace(url);
  }
  return true;
};
